export const defaultSeoConfig = {
  key: 'index',
  title: 'HSK Mock: the only official platform for practising HSK and YCT tests',
  description:
    'Web and mobile app, developed in partnership with the HSK exam board, for understanding the world’s most popular Chinese language proficiency tests and for practising HSK and YCT tests with real recent past papers.  Descriptions, test format, vocab, listening, reading and writing samples and mock tests for all HSK levels',
}

export default [
  {
    key: 'index',
    title: 'HSK Mock: the only official platform for practising HSK and YCT tests',
    description:
      'Web and mobile app, developed in partnership with the HSK exam board, for understanding the world’s most popular Chinese language proficiency tests and for practising HSK and YCT tests with real recent past papers.  Descriptions, test format, vocab, listening, reading and writing samples and mock tests for all HSK levels',
  },
  {
    name: 'HskAbout',
    key: 'YCT 1',
    title: 'YCT 1 on the only official platform for practising YCT tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Youth Chinese Test Level 1 (YCT1).  Developed in partnership with the HSK exam board and available via web and mobile app',
  },
  {
    name: 'HskAbout',
    key: 'YCT 2',
    title: 'YCT 2 on the only official platform for practising YCT tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Youth Chinese Test Level 2 (YCT2).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'YCT 3',
    title: 'YCT 3 on the only official platform for practising YCT tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Youth Chinese Test Level 3 (YCT3).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'YCT 4',
    title: 'YCT 4 on the only official platform for practising YCT tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Youth Chinese Test Level 4 (YCT4).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'HSK 1',
    title: 'HSK 1 on the only official platform for practising HSK tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 1 (HSK1).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'HSK 2',
    title: 'HSK 2 on the only official platform for practising HSK tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 2 (HSK2).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'HSK 3',
    title: 'HSK 3 on the only official platform for practising HSK tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 3 (HSK3).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'HSK 4',
    title: 'HSK 4 on the only official platform for practising HSK tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 4 (HSK4).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'HSK 5',
    title: 'HSK 5 on the only official platform for practising HSK tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 5 (HSK5).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'HSK 6',
    title: 'HSK 6 on the only official platform for practising HSK tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 6 (HSK6).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'YCTExamination',
    key: 'YCT 1',
    title: 'Real recent past YCT 1 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Youth Chinese Test Level 1 (YCT1), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'YCTExamination',
    key: 'YCT 2',
    title: 'Real recent past YCT 2 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Youth Chinese Test Level 2 (YCT2), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'YCTExamination',
    key: 'YCT 3',
    title: 'Real recent past YCT 3 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Youth Chinese Test Level 3 (YCT3), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'YCTExamination',
    key: 'YCT 4',
    title: 'Real recent past YCT 4 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Youth Chinese Test Level 4 (YCT4), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HSKExamination',
    key: 'HSKE 1',
    title: 'HSK 1 on the only official platform for practising HSK tests',
    description:
      'Practice HSK 1 with official mock exams from HSK Mock. Use real HSK exam questions, get instant results, and prepare with accurate scoring standards.',
  },
  {
    name: 'HSKExamination',
    key: 'HSKE 2',
    title: 'HSK 2 on the only official platform for practising HSK tests',
    description:
      'Take HSK 2 mock exams online with HSK Mock, the official HSK platform. Access real HSK exam questions and receive instant, accurate results.',
  },
  {
    name: 'HSKExamination',
    key: 'HSKE 3',
    title: 'HSK 3 on the only official platform for practising HSK tests',
    description:
      'Prepare for HSK 3 with official mock exams from HSK Mock. Practice using real HSK exam questions and reliable scoring criteria from the exam board.',
  },
  {
    name: 'HSKExamination',
    key: 'HSKE 4',
    title: 'HSK 4 on the only official platform for practising HSK tests',
    description:
      'HSK 4 mock exams online with HSK Mock, the official HSK platform. Access real HSK exam questions and prepare with accurate scoring standards.',
  },
  {
    name: 'HSKExamination',
    key: 'HSKE 5',
    title: 'HSK 5 on the only official platform for practising HSK tests',
    description:
      'Get official HSK 5 mock exams from HSK Mock. Use real exam questions provided by the test board and practice with trusted scoring criteria.',
  },
  {
    name: 'HSKExamination',
    key: 'HSKE 6',
    title: 'HSK 6 on the only official platform for practising HSK tests',
    description:
      'HSK 6 mock exams online with HSK Mock, the official exam practice platform. Access real HSK exam questions and prepare with accurate scoring standards.',
  },
  {
    name: 'HSKExamination',
    key: 'HSKE 7',
    title: 'HSK 7-9 on the only official platform for practising HSK tests',
    description:
      'Prepare for the HSK 7–9 exam with official mock tests from HSK Mock. Access real exam questions from the test board and practice with accurate scoring.',
  },
  {
    name: 'spcExamination',
    key: 'Spc Examination',
    title: 'HSK Mock: the only official platform for practising HSK and YCT tests',
    description:
      'Take a free online HSK level test with HSK Mock, the official exam practice platform. Instantly check your HSK level with authentic questions and accurate results.',
  },
  {
    name: 'ChooseLevel',
    key: 'Choose Level',
    title: 'HSK Mock: the only official platform for practising HSK and YCT tests',
    description:
      'Select from HSK 1–9, HSK Speaking, or YCT mock exams on HSK Mock, the official exam practice platform. Prepare with real questions and accurate scoring.',
  },
  {
    name: 'HomeIndex',
    key: 'Home Index',
    title: 'HSK Mock: the only official platform for practising HSK and YCT tests',
    description:
      'HSK Mock is the only official platform for practice of HSK, HSK Speaking, and YCT exams. Access real exam questions, accurate scoring, and mock tests for all levels.',
  },
  {
    name: 'AboutInfo',
    key: 'About Info',
    title: 'HSK Mock: the only official platform for practising HSK and YCT tests',
    description:
      'HSK Mock is the official platform for HSK, HSK Speaking, and YCT mock exams. Backed by Chinese Testing International, with real exam questions and accurate scoring.',
  },
]
